(function () {
  function initReviews(root) {
    if (typeof Swiper === 'undefined') return;

    var swiperEl = root.querySelector('.recent-reviews__swiper');
    var prevBtn = root.querySelector('.recent-reviews__nav--prev');
    var nextBtn = root.querySelector('.recent-reviews__nav--next');
    var slideCount = parseInt(root.getAttribute('data-slide-count'), 10) || 0;
    var dots = Array.prototype.slice.call(root.querySelectorAll('.recent-reviews__pagination-dot'));

    if (!swiperEl || slideCount < 1) return;

    function updatePagination(swiper) {
      if (!dots.length) return;
      var realIdx = swiper.realIndex % slideCount;
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === realIdx);
      });
    }

    var swiperOptions = {
      loop: true,
      slidesPerView: 1,
      speed: 400,
      grabCursor: true,
      spaceBetween: 20,
      watchOverflow: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      on: {
        afterInit: function (swiper) {
          updatePagination(swiper);
        },
        slideChangeTransitionEnd: function (swiper) {
          updatePagination(swiper);
        },
      },
    };

    if (slideCount > 1) {
      swiperOptions.autoplay = {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    }

    var swiperInstance = new Swiper(swiperEl, swiperOptions);

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        if (!swiperInstance) return;
        if (swiperInstance.params.loop) {
          swiperInstance.slideToLoop(index);
        } else {
          swiperInstance.slideTo(index);
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-recent-reviews]').forEach(initReviews);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
